import React from "react"
import styled from "styled-components"
import { useTranslation } from "react-i18next"
import Icon from "@mdi/react"
import { mdiEarth } from "@mdi/js"
import { Link } from "gatsby"
import SEO from "../components/seo"

const Container = styled.div`
  width: 66.6%;

  @media screen and (max-width: 415px) {
    width: 100%;
  }
`

const SupportPageDetail = styled.div`
  min-height: 500px;
  margin-right: 24px;
  .supportPage__detailTitle {
    padding: 20px 22px;
    background: var(--ud-greyeb);
    border-radius: 3px;
    svg {
      font-size: 12px;
      line-height: 12px;
      margin-right: 15px;
      width: 12px;
    }
  }
  h1.supportPage__detailTitle {
    padding: 20px 22px 35px 22px;
    font-size: 17px;
  }
  .supportPage__detailContent {
    margin: 24px;
    p {
      line-height: 1.6;
      margin: 0 0 10px;
      color: #313131;
      font-weight: 300;
    }

    div {
      color: #313131;
      font-weight: 300;
    }
    img {
      height: 100%;
      width: 100%;
      max-width: inherit;
    }
  }
`

const TopBackBtn = styled(Link)`
  color: #2a3795;
  border: 0;
  background: tranparent;
  font-size: 14px;
  margin: 18px 20px;
  font-weight: 700;
  display: block;
`

const BottomBackBtn = styled(Link)`
  color: white;
  background: #2a3795;
  border: 1px solid #ebebeb;
  box-sizing: border-box;
  border-radius: 3px;
  font-size: 14px;
  padding: 17px 33px;
  margin-left: 24px;
  margin-bottom: 24px;
  font-weight: 700;
  display: inline-block;
`

export default ({ data, pageContext, location }) => {
  const { t } = useTranslation()
  const { faq } = pageContext
  return (
    <Container>
      <SEO title={faq.title} description={faq.preview}/>
      <SupportPageDetail>
        <TopBackBtn to={`/${faq.lang}/`}>
          {`< ${t("support_back_button")}`}
        </TopBackBtn>
        {faq.title && (
          <h1 className="supportPage__detailTitle">
            <Icon path={mdiEarth} size={0.5} />
            <b>
            <span
              dangerouslySetInnerHTML={{
                __html: `${faq.title}`,
              }}
            />
            </b>
          </h1>
        )}
        {faq.content && (
          <div
            className="supportPage__detailContent"
            dangerouslySetInnerHTML={{ __html: faq.content }}
          />
        )}
        <BottomBackBtn to={`/${faq.lang}/`}>
          {t("support_back_button")}
        </BottomBackBtn>
      </SupportPageDetail>
    </Container>
  )
}
